export default __webpack_public_path__ + "static/assets/9c6670a724fcb93f0458df6bd78a88a1.png";